module.exports = __webpack_public_path__ + "static/media/JOIA.b7f05bf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/JOIA.jpg
// module id = 1759
// module chunks = 1